const environment = `${process.env.REACT_APP_GOUSTO_API_ORIGIN}`

export const smartRecruitersAPI = {
  jobs: `https://api.smartrecruiters.com/v1/companies/${environment.includes('production') ? 'Gousto1' : 'Gousto-Sandbox1'}/postings`,
}
